<template>
	<WebViewLayout>
		<NewUserRewardContent />
	</WebViewLayout>
</template>
<script setup lang="ts">
import NewUserRewardContent from '@components/legal/new-user-reward-content.vue';
import WebViewLayout from '@views/webview/web-view-layout.vue';
</script>
